import { PurePtr } from '@pure-ptr/core';
import React from 'react';
import { DataTableHeader } from '../dataTableHeader';
import { Field } from '../dataTableHeader/DataTableHeader';
import { TableFilterState } from '../XDataGrid';

interface AdvancedTableFiltersProps {
    fields: Field[];
    pageName: string;
    pending: boolean;
    filtersPtr: PurePtr<TableFilterState['filters']>;
    refreshCriteriaList?: ( setDefault : boolean ) => void;
    intl: any;
    criteria: any;
    selectedCriteria: any;
    criteriasSaveEnabled: boolean;
    userSessionId?:any;
    actions: {
        saveCriteriaFilter: (criteria: any, callback: () => void) => void;
        updateCriteriaFilter: (criteria: any, callback: () => void) => void;
        searchGetByName: (name: { name: string },callback?: () => void) => void;
    };
}

export default function AdvancedTableFilters({
    fields, pageName, 
    filtersPtr,
    pending, intl,
    selectedCriteria, 
    refreshCriteriaList,
    criteriasSaveEnabled, userSessionId,
    actions: { saveCriteriaFilter, updateCriteriaFilter }
}: AdvancedTableFiltersProps) {
    const filterPtr = filtersPtr.at('filter'),
        { filter, customFilter } = filtersPtr.value;

    function handleFilter(newFilter,isAddFilter) {
        if (!pending) {            
            const mergedFilter =
                !newFilter?.equator && !newFilter?.field && !newFilter?.value
                    ? [...filter]
                    : [newFilter,...filter];
                            
            filterPtr.set(mergedFilter);
        }
    }

    function handleDeleteFilter(deletedFilter, index) {
        filterPtr.removeAt(index);
    }

    function handleUpdateFilter(newFilterObj, index) {
        if (index !== null) {
            filterPtr.at(index).set(newFilterObj);
        }
    }

    function handleFilterClear() {
        filtersPtr.update( prev => ({
            ...prev,
            selectedFilterId: null,
            filter: [],
        }));
    }

    function SaveFilterCallback(handleClose, setDefault) {
        handleClose();
        refreshCriteriaList && refreshCriteriaList( setDefault );    
    }

    function handleFilterSave(filterCriteria, handleClose, existingCriteria) {
        let searchCriteria = {
            ...filterCriteria,
            name: pageName,
        }

        if (existingCriteria && existingCriteria.id) {
            updateCriteriaFilter(searchCriteria, () => {
                SaveFilterCallback(handleClose, filterCriteria.isDefault )
            });
        } 
        else {
            saveCriteriaFilter(searchCriteria, () => {
                SaveFilterCallback(handleClose, filterCriteria.isDefault)
            });
        }
    }

    return (
        <DataTableHeader
            fields={fields}
            intl={intl}
            filter={filterPtr.value}
            significance={filtersPtr.value?.significance}
            customFilter={customFilter}
            onFilterChange={handleFilter}
            onFilterDelete={handleDeleteFilter}
            onFilterClear={handleFilterClear}
            onFilterSave={handleFilterSave}
            onFilterUpdate={handleUpdateFilter}
            criteria={selectedCriteria}
            saveEnabled={criteriasSaveEnabled}
            pending={pending}
            pageName={pageName}
            userSessionId={userSessionId}
        />
    );
};                   